// Components
const BreederDetailsComponent = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: 'breeder-details-component' */ "@/app/views/main-view/breeders/components/breeder-details-component/breeder-details-component.vue"
	)

// Third party libraries
import DatePicker from "vue2-datepicker"

//Service
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js"
import BreedService from "@/app/services/main/breeds/breeds-service"
import PaymentAPI from "@/app/services/main/payment/payment-service.js"

// Utils
import { vuelidateUtil } from "@/utils/vuelidate-util.js"

// Constants
import { STATUS_CODES, ERROR_MSG, PUPPY_SELL_STATUS, STATES, TRANSACTION_STATUS } from "@/app/constants/constants"

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js"
import { numberFormatMixins } from "@/app/mixins/modules/number-format-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { imageUploadMixins } from "@/app/mixins/utils/image-upload-mixins"

export default {
	name: "PuppySellingDetailsContainer",
	components: { DatePicker, BreederDetailsComponent },
	mixins: [toastMessageMixins, numberFormatMixins, dateMixins, imageUploadMixins],
	data() {
		return {
			isEditAPILoading: false,
			isAPILoading: false,
			image: require("@/assets/images/_shared/dog-confirm.png"),
			date: "",
			breederNotes: "",
			notes: "",
			fromBreederDetails: false,
			genderList: [
				{ name: "Male", value: "M" },
				{ name: "Female", value: "F" },
			],
			theads: [
				{ name: "Payment Method", sortLabel: null, isDesc: false, style: null },
				{ name: "Customer Name", sortLabel: null, isDesc: false, style: null },
				{ name: "Status", sortLabel: null, isDesc: false, style: null },
				{ name: "Message", sortLabel: null, isDesc: false, style: null },
				{ name: "Price", sortLabel: null, isDesc: false, style: null },
			],
			stateOptions: [
				{
					value: "NSW",
					name: "New South Wales",
				},
				{
					value: "VIC",
					name: "Victoria",
				},
				{
					value: "QLD",
					name: "Queensland",
				},
				{
					value: "WA",
					name: "Western Australia",
				},
				{
					value: "SA",
					name: "South Australia",
				},
				{
					value: "TAS",
					name: "Tasmania",
				},
				{
					value: "NT",
					name: "Northern Territory",
				},
				{
					value: "ACT",
					name: "Australian Capital Territory",
				},
			],

			//Breeder
			breederId: "",
			code: "",
			state: "",
			fullname: "",
			email: "",
			mobileNumber: "",
			address: "",
			isVerifiedBreeder: false,

			//Puppy details
			puppySellId: "",
			status: "",
			breedId: "",
			breedName: "",
			microchipNumber: "",
			birthdate: "",
			price: "",
			priceStatus: "",
			gender: "",
			colour: "",
			headline: "",
			body: "",
			images: [],
			breedList: [],
			createdAt: "",
			refundRemarks: "",
			isDetailsUpdated: false,
			sku: "",
			puppyName: "",
			notesHistory: [],
			isBreederDeleted: false,

			//Customer details
			buyerDetails: {},
			showCustomerDetails: false,
			isRequestRefundValid: true,
			customerName: "",
			customerEmail: "",
			customerMobileNumber: "",
			customerShippingAddress: "",
			customerBillingAddress: "",
			totalAmount: "",
			paymentMethod: "",
			referenceNumber: null,
			transactionHistory: [],
			recipientName: "",

			// Transaction Details
			transactionDate: "",

			// Payments
			payment: [],

			// Loader
			isPaymentLoading: false,

			// Images
			imageRef: [],
			fileBlob: null,
			filesToSend: [],
			setAsPrimary: 0,
			updatedImages: [],
			deletedImages: [],

			showPuppyStatusOptions: false,
			allPuppyStatusList: [
                { id: "A", name: "AVAILABLE" },
                { id: "PENDING_PAYMENT", name: "PENDING PAYMENT" },
                { id: "S", name: "SOLD" },
                { id: "REQUEST_REFUND", name: "REQUEST FOR REFUND" },
                { id: "REFUNDED", name: "REFUNDED" },
                { id: "PICKED_UP", name: "PICKED UP" },
                { id: "DELETED", name: "DELETED" },
                { id: "P", name: "PENDING" },
				{ id: "HIDDEN", name: "HIDDEN" },
            ],
			puppyStatusList: this.allPuppyStatusList,
			imageTypeList: ['image/svg','image/png','image/jpg','image/jpeg','image/gif','image/raw', 'image/webp'],
		}
	},
	computed: {
		validationRules() {
			let fields = {
				notes: {},
				breederNotes: {},
				breederId: {},
				state: {},
				fullname: {},
				email: {},
				mobileNumber: {},
				address: {},
				breedName: {},
				microchipNumber: {},
				birthdate: {},
				price: {},
				gender: {},
				code: {},
			}

			fields = vuelidateUtil.setRequiredValidation(fields, "code")
			fields = vuelidateUtil.setRequiredValidation(fields, "fullname")
			fields = vuelidateUtil.setRequiredValidation(fields, "mobileNumber")
			fields = vuelidateUtil.setRequiredValidation(fields, "state")
			fields = vuelidateUtil.setRequiredValidation(fields, "address")
			fields = vuelidateUtil.setRequiredValidation(fields, "email")
			fields = vuelidateUtil.setEmailValidation(fields, "email")

			fields = vuelidateUtil.setRequiredValidation(fields, "breedName")
			fields = vuelidateUtil.setRequiredValidation(fields, "birthdate")
			fields = vuelidateUtil.setRequiredValidation(fields, "price")
			fields = vuelidateUtil.setMinValueValidation(fields, "price", 0)
			fields = vuelidateUtil.setRequiredValidation(fields, "gender")

			return fields
		},
		statusBadge() {
			const statusMap = {
				["PENDING"]: "status--pending",
				["PENDING PAYMENT"]: "status--pending",
				["SOLD"]: "status--sold",
				["REFUNDED"]: "status--sold",
				["AVAILABLE"]: "status--available",
				["PICKED UP"]: "status--available",
				["REQUEST FOR REFUND"]: "status--pending",
			}

			return statusMap[this.status] || "status--declined"
		},

		verifiedStatus() {
			return this.isVerifiedBreeder ? "Verified Breeder" : "Unverified Breeder"
		},
		timelineItems() {
			let items = []

			if (this.transactionHistory) {
				for (const data of this.transactionHistory) {
					const { date, status, remarks, submittedBy } = data
					let transDate = this.formatDateTime(date)
					let content = PUPPY_SELL_STATUS[status] ? PUPPY_SELL_STATUS[status] : status

					if (status === "D" && remarks != "" && remarks) {
						content += `<br> <p class="color-warning mb-0">Reason: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					} else if (status === "P" && remarks != "" && remarks) {
						content += `<br> <p class="color-warning mb-0">Reason: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					} else if (status === "REQUEST_REFUND" && remarks != "" && remarks) {
						content += `<br> <p class="color-warning mb-0">Reason: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					} else if (status === "REFUNDED") {
						content += `<br> <p class="color-warning mb-0">${remarks}</p>`
						content += `<p class="color-warning mb-0">Approved By: ${submittedBy}</p>`
					} else if (status === "DISAPPROVED_REFUND" && submittedBy) {
						// DISAPPROVED REFUND
						content += `<br> <p class="color-warning mb-0">Reason: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					} else if (status === "S" && !!remarks && !!submittedBy) {
						// S - SOLD
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					}else if (status === "S" && !!remarks) {
						// S - SOLD
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
					} else if (status === "PENDING_PAYMENT") {
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					} else if ((status === "A" && submittedBy) || (status === PUPPY_SELL_STATUS.HIDDEN && submittedBy)) {
						// A - Available
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					} else if (status === "CANCELED" && submittedBy) {
						// CANCELED - CANCELLED
						content += `<br> <p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					} else if (status === "F" && submittedBy) {
						// F - FAILED
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					} else if (submittedBy && submittedBy != "") {
						content += `<br> <p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					}

					items.push({
						htmlMode: true,
						content: `[${transDate}] : ${content}`,
					})
				}
			}

			return items;
		},
		displayTimeline() {
			const display = this.status === "SOLD" ||
			this.status === "REQUEST FOR REFUND" ||
			this.status === "CANCELLED" ||
			this.status === "REFUNDED" ||
			this.status === "PICKED UP" ||
			this.status === "PENDING PAYMENT" ||
			this.status === "AVAILABLE" ||
			this.status === "HIDDEN" ||
			this.status === "A"

			return display
		},
		refundRequestRemark() {
			if (this.transactionHistory) {
				const filteredTransactionHistory = this.transactionHistory.filter(
					(transaction) => transaction.status === "REQUEST_REFUND"
				)
				const lastValue = filteredTransactionHistory[0];

				return lastValue.remarks
			} else {
				return "No Remarks"
			}
		},
	},
	watch: {
		notes(val) {
			if (val != "") {
				this.$v.notes.$reset()
			}

			this.isDetailsUpdated = val != this.tmpnotes
		},
		breederNotes(val) {
			if (val != "") {
				this.$v.breederNotes.$reset()
			}
		},
		breedName(value) {
			this.isDetailsUpdated = value != this.tmpbreedName
		},
		birthdate(value) {
			this.isDetailsUpdated = value != this.tmpbirthdate
		},
		price(value) {
			this.isDetailsUpdated = value != this.tmpprice
		},
		priceStatus(value) {
			this.isDetailsUpdated = value != this.tmppriceStatus
		},
		gender(value) {
			this.isDetailsUpdated = value != this.tmpgender
		},
		microchipNumber(value) {
			this.isDetailsUpdated = value != this.tmpmicrochipNumber
		},
		colour(value) {
			this.isDetailsUpdated = value != this.tmpcolour
		},
		headline(value) {
			this.isDetailsUpdated = value != this.tmpheadline
		},
		body(value) {
			this.isDetailsUpdated = value != this.tmpbody
		},
		images(value) {
			this.isDetailsUpdated = value.length != this.tmpimages
		},
		setAsPrimary(value) {
			this.isDetailsUpdated = value != this.tmpSetAsPrimary || this.tmpimages != this.images.length
		},
		puppyName(value) {
			this.isDetailsUpdated = value != this.tmppuppyName
		},
		buyerDetails(value){
			if (value)
				this.showCustomerDetails = Object.keys(value).length > 0;
		},
	},
	async created() {
		await this.getBreedList()
		await this.getPuppySellingDetails(this.$route.params.id)
		this.fromBreederDetails = this.$route.query.fromBreeder ? true : false
	},
	methods: {
		createOptionBreed(breed) {
			// this.addedBreedName = breed;
			return { name: breed, id: `0-${breed}` }
		},
		setSelected(e) {
			if (!e) {
				// To trigger the validation
				this.$v.breedName.$touch()
				this.breedId = ""
				this.breedName = ""
				return
			}
			this.breedId = e.id
			this.breedName = e.name
		},
		setSelectedState(e) {
			if (!e) {
				// To trigger the validation
				this.$v.state.$touch()
				return
			}
			this.state = { name: e.name, value: e.value }
		},
		setSelectedGender(e) {
			if (!e) {
				// To trigger the validation
				this.$v.gender.$touch()
				return
			}
		},
		beforeToday(date) {
			return date > new Date()
		},
		onBlur(field) {
			this.$v[field].$touch()
		},
		dateChange(e) {
			if (!e) {
				this.$v.birthdate.$touch()
				return
			}
		},
		getBreedList() {
			BreedService.getBreeds().then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.breedList = res.data.data
				} else {
					const { ERROR_GET_BREED_LIST } = this.toastMessages.breed()
					this.showAPIErrorToast(ERROR_GET_BREED_LIST, res)
				}
			})
		},
		async getPuppySellingDetails(puppySellId) {
			if (!puppySellId) {
				return;
			}

			this.isAPILoading = true;

			try{
				const response = await puppySellService.getPuppyDetailsById(puppySellId);
				if (response.status === STATUS_CODES.SUCCESS) {
					this.setFieldsData(response.data)
				} else {
					this.showAPIErrorToast("Unable to fetch puppy sell details.", response)
				}
			}
			catch(err){
				this.showGenericErrorToast()
			} finally{
				this.isAPILoading = false;
			}
		
		},
		setFieldsData(data) {
            const { buyerDetails, transactionHistory, payment, notesHistory, recipientName } = data
			this.recipientName = recipientName;
            //Breeder
            this.breederId = data.breeder.id;
            this.code = data.breeder.code;
            this.state = data.breeder.state === "" || !data.breeder.state ? "" : { value: data.breeder.state, name: STATES[data.breeder.state], };
            this.fullname = data.breeder.name;
            this.email = data.breeder.email;
            this.notesHistory = notesHistory;

            let tempMobile = "";
            if (data.breeder.mobileNumber) {
                tempMobile = data.breeder.mobileNumber.split("");
                tempMobile.splice(4, 0, "-");
            }

            this.mobileNumber = tempMobile.join("");
            this.address = data.breeder.address;
            this.isVerifiedBreeder = data.breeder.verified;
			this.breederNotes = data.breeder.reason ? data.breeder.reason : "";
			this.isBreederDeleted = data.breeder.status === 'D';

            //Puppy details
            this.puppySellId = data.puppyDetails.id;
            this.status = PUPPY_SELL_STATUS[data.puppyDetails.status];
			this.puppyRawStatus = data.puppyDetails.status;

			this.puppyStatusList = [...this.allPuppyStatusList].filter(status => status.id !== data.puppyDetails.status);

            this.breedId = data.puppyDetails.breedId;
            this.breedName = data.puppyDetails.breedName;
            this.microchipNumber = data.puppyDetails.microchipNumber;
            this.birthdate = data.puppyDetails.birthdate
                ? new Date(data.puppyDetails.birthdate.replace(/-/g, "/"))
                : data.puppyDetails.birthdate;
            this.price = data.puppyDetails.price;
            this.priceStatus = data.puppyDetails.priceStatus;
            this.gender =
                data.puppyDetails.gender === ""
                    ? ""
                    : data.puppyDetails.gender === "M"
                    ? { name: "Male", value: "M" }
                    : { name: "Female", value: "F" };

            this.colour = data.puppyDetails.colour;
            this.headline = data.puppyDetails.headline;
            this.body = data.puppyDetails.body;
            this.images = data.puppyDetails.images.reverse();
            this.notes = data.puppyDetails.reason
                ? data.puppyDetails.reason
                : "";
            this.createdAt = data.puppyDetails.createdAt;
            this.sku = data.puppyDetails.puppyReferenceNumber;
            this.puppyName = data.puppyDetails.puppyName;

            //Set Temp data
            this.tmpbreedName = data.puppyDetails.breedName;
            this.tmpbirthdate = data.puppyDetails.birthdate
                ? new Date(data.puppyDetails.birthdate.replace(/-/g, "/"))
                : data.puppyDetails.birthdate;
            this.tmpprice = data.puppyDetails.price;
            this.tmppriceStatus = data.puppyDetails.priceStatus;
            this.tmpgender =
                data.puppyDetails.gender === ""
                    ? ""
                    : data.puppyDetails.gender === "M"
                    ? { name: "Male", value: "M" }
                    : { name: "Female", value: "F" };
            this.tmpmicrochipNumber = data.puppyDetails.microchipNumber;
            this.tmpcolour = data.puppyDetails.colour;
            this.tmpheadline = data.puppyDetails.headline;
            this.tmpbody = data.puppyDetails.body;
            this.tmpimages = data.puppyDetails.images.length;
            this.tmppuppyName = data.puppyDetails.puppyName;
            this.tmpnotes = data.puppyDetails.reason
                ? data.puppyDetails.reason
                : "";
            //Select the primary image
            data.puppyDetails.images.forEach((img, i) => {
                if (img.primary) {
                    this.setAsPrimary = i;
                }
            });
            this.tmpSetAsPrimary = this.setAsPrimary;

            this.transactionHistory = transactionHistory;

			// const filteredTransactionHistory = transactionHistory.filter((transaction) => transaction.status === "REQUEST_REFUND");
			const lastValue = transactionHistory && transactionHistory.length > 0 ? transactionHistory[0] : null;
			// this means that the status has been manually updated even tho the user request for a refund
			if(lastValue && lastValue.remarks === "Puppy status manually updated."){
				this.isRequestRefundValid = false;
			}

            // Payments
            this.payment =
                payment &&
                payment.map((dt, idx) => {
                    return { ...dt, index: idx };
                });

            //Customer details
            // if (buyerDetails) {
            //     this.puppySellPurchaseId = buyerDetails.id;
            //     this.customerName = buyerDetails.recipientName;
            //     this.customerEmail = buyerDetails.email;
            //     this.customerMobileNumber = buyerDetails.mobileNumber;
            //     this.customerShippingAddress =
            //         buyerDetails.shippingAddress.address;
            //     this.customerBillingAddress =
            //         buyerDetails.billingAddress.address;
            //     this.referenceNumber = buyerDetails.referenceNumber;

            //     this.totalAmount = buyerDetails.totalAmount;
            //     this.paymentMethod = buyerDetails.paymentMethod;
            //     this.transactionDate = buyerDetails.createdAt;

                this.buyerDetails = buyerDetails;
            // }
            // else{
            // 	// this.buyerDetails = {};
			// 	this.referenceNumber = "";
            // }

            if (data.puppyDetails.status === "DELETED") {
                this.notes = `Removed by ${data.puppyDetails.validatedBy}`;
            }
        },

		refreshPuppyDetails() {
			this.getPuppySellingDetails(this.$route.params.id)
		},
		showEmail(email) {
			if (email) {
				window.location.href = `mailto:${email}`
			}
		},
		displayUpdatePayment(data) {
			return data.isShowButton
		},
		mobileFormat(mobileNumber) {
			if (mobileNumber) {
				let data = mobileNumber.split("")
				data.splice(4, 0, "-")
				return data.join("")
			} else {
				return ""
			}
		},
		submitApproval() {
			let modalContent = `<div class="d-flex align-items-center flex-column">`
			modalContent += `<p class="mb-0 my-2" style="color: fd7e14">Are you sure you want to approve the request for refund?</p>`
			modalContent += `<p class="mb-3"><span class="font-weight-bold">${this.buyerDetails[0].paymentMethod.toUpperCase()}</span>: $${
				this.buyerDetails[0].totalAmount
			}</p>`
			modalContent += `<p class="mb-0">Enter Refund Amount:</p>`
			modalContent += "</div>"
			this.$swal({
				titleText: "Request For Refund",
				html: modalContent,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				showCloseButton: true,
				input: "number",
				customClass: {
					input: "mt-1 refund-input",
				},
				inputAttributes: {
					min: 1,
				},
				inputValidator: (value) => {
					if (!value || parseFloat(value) === 0) {
						return "Please enter refund amount"
					}

					if (parseFloat(value) > parseFloat(this.buyerDetails[0].totalAmount)) {
						return "Refund amount should not be greater than ordered price"
					}

					if (parseFloat(value) < 0) {
						return "Refund amount should not be negative"
					}
				},
			}).then((result) => {
				if (result.value) {
					const requestDetails = {
						status: "APPROVED",
						puppyToSellId: parseInt(this.$route.params.id),
						remarks: "",
						amount: result.value,
						buyerId: this.buyerDetails && Array.isArray(this.buyerDetails) ? this.buyerDetails[0].userId : null,
					}

					this.processRefund(requestDetails)
				}
			})
		},
		async submitDisapproval() {
			const { value: remarks } = await this.$swal({
				titleText: `Reason For Disapproval`,
				html: `<div style="margin:2rem"><img src=${this.image} style="" height="200"></div><p>Are you sure you want to disapprove this request? Please state your reason in the textbox below.</p>`,
				input: "textarea",
				inputPlaceholder: "Type your reason here...",
				inputAttributes: {
					"aria-label": "Type your reason here",
				},
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				showCloseButton: true,
				inputValidator: (remark) => {
					if (!remark) {
						return "You must input a reason for disapproval!"
					}
				},
			})

			if (remarks) {
				const requestDetails = {
					status: "DISAPPROVED",
					puppyToSellId: parseInt(this.$route.params.id),
					amount: "",
					remarks: remarks,
					buyerId: this.buyerDetails && Array.isArray(this.buyerDetails) ? this.buyerDetails[0].userId : null,
				}

				this.processRefund(requestDetails)
			}
		},

		async processRefund(details) {
			this.isEditAPILoading = true

			try {
				const response = await puppySellService.putPuppyPurchaseRefundApproval(details)

				if (response.status === STATUS_CODES.SUCCESS) {
					if (response.data.status.toLowerCase() === TRANSACTION_STATUS.REFUNDED.toLowerCase()) {
						this.showCustomSuccessToast(null, `Refund Request has been approved.`)
					} else {
						this.showCustomSuccessToast(null, `Payment was updated to sold manually, thus the refund should also be refunded manually.`)
					}
					
					this.getPuppySellingDetails(this.$route.params.id)
				} else {
					this.showAPIErrorToast(ERROR_MSG.INTERNAL_ERROR_TITLE, response)
				}
				this.isEditAPILoading = false
			} catch (error) {
				this.showGenericErrorToast()
				this.isEditAPILoading = false
			}
		},

		// Image
		async onUploadImage(event) {
			// Change Object of images to Array
			const images = Object.values(event.target.files)

			// Validate Multiple Images as Array
			// let valid = this.validateMultipleImages(images)

			// // compress image if more than 2mb
			// const files = await this.compressMultipleImages(images)

			// // do nothing when user cancels Upload
			// if (!valid) {
			// 	// reset uploader
			// 	this.$refs.uploader.value = ""
			// 	return
			// }

			this.fileBlob = images

			// Throw Error when uploaded images is more than 7
			if (images.length > 7 || this.images.length > 7 || this.images.length + images.length > 7) {
				this.showCustomErrorToast("Error", "Unable to upload more than 7 images.")
				return
			}

			this.fileBlob.forEach(async (file, idx) => {
				let valid  = await this.validateImageWithType(file, this.imageTypeList);
				if ( valid ) {
					let compressFile = await this.compressImage(file)
					let reader = new FileReader()
					reader.readAsDataURL(compressFile)
					let primary = false

					if (this.images.length === 0 && idx === 0) {
						primary = true
					}

					reader.onload = async () => {
						// Push images to an array and display with images
						if (this.images.length <= 7) {
							await this.images.push(reader.result)
							await this.filesToSend.push(compressFile)
							await this.imageRef.push({ primary, name: compressFile.name })
						} else {
							return
						}
					}
				}
			})
		},

		removeImage(index, image) {
			this.images.splice(index, 1)
			let isPrimaryImageDeleted = false

			if (parseInt(this.setAsPrimary) < 0) {
				this.setAsPrimary = 0
			} else if (parseInt(this.setAsPrimary) > parseInt(index)) {
				this.setAsPrimary = this.setAsPrimary - 1
			} else if (parseInt(this.setAsPrimary) === parseInt(index)) {
				this.setAsPrimary = 0
				isPrimaryImageDeleted = true
			}

			const isNewImage = !image.id //Newly added image
			if (!isNewImage) {
				this.deletedImages.push(image)

				if (isPrimaryImageDeleted) {
					if (this.images.length === 0) {
						this.updatedImages = []
						return
					}
					this.updatedImages = []
					this.updatedImages.push({ ...this.images[0], primary: true })
					// this.imageRef[0].primary = true;
				}
			} else {
				this.imageRef.splice(index, 1)
				this.filesToSend.splice(index, 1)
			}
		},

		setPrimaryPhoto(index, image) {
			const isNewImage = !image.id //Newly added image
			if (isNewImage) {
				//Update form
				const ctr = this.images.length - index
				const imageRefIdx = this.imageRef.length - ctr

				this.imageRef[this.setAsPrimary].primary = false
				this.imageRef[imageRefIdx].primary = true
				this.updatedImages = []
			} else {
				if (this.updatedImages.length === 0) {
					//Reset all newly added images to primary false
					this.resetPrimaryPhoto("imageRef")

					//Insert the new primary photo to updatedImages
					this.updatedImages.push({ ...this.images[index], primary: true })
				} else {
					//Reset all newly added images to primary false
					this.resetPrimaryPhoto("imageRef")

					this.updatedImages = []
					//Insert the new primary photo to updatedImages
					this.updatedImages.push({ ...this.images[index], primary: true })
				}
			}
		},

		//Reset primary photo of newly added images and previous images
		resetPrimaryPhoto(images) {
			if (this[images].length != 0) {
				this[images] = this[images].map((img) => {
					return {
						...img,
						primary: false,
					}
				})
			}
		},

		async updatePuppySelling() {
			this.isEditAPILoading = true
			try {
				const details = {
					formData: {
						id: this.puppySellId,
						breedId: this.breedId,
						microchipNumber: this.microchipNumber,
						price: this.price,
						priceStatus: this.priceStatus,
						birthdate: this.birthdate,
						gender: this.gender.value,
						colour: this.colour,
						headline: this.headline,
						body: this.body,
						status: this.status,
						imageRef: this.imageRef, //Image reference of the newly added photo
						updatedImages: this.updatedImages, //New primary photo
						deletedImages: this.deletedImages, //Images to be deleted in the database
						puppyName: this.puppyName,
						reason: this.notes
					},
					images: this.filesToSend.length ? this.filesToSend : [],
				}

				const response = await puppySellService.updatePuppyDetails(details)

				if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					setTimeout(async () => {
						this.imageRef = []
						this.images = []
						this.deletedImages = []
						this.filesToSend = []
						await this.getPuppySellingDetails(this.$route.params.id)
						this.isEditAPILoading = false
						this.isDetailsUpdated = false
						this.showCustomSuccessToast(null, `Puppy details has been successfully updated!`)
					}, 2500)
				} else {
					this.showAPIErrorToast("Unable to update puppy sell details.", response)
					this.isEditAPILoading = false
				}
			} catch (err) {
				// Catch any error
				this.showGenericErrorToast()
				this.isEditAPILoading = false
			}
		},

		translateStatus(status) {
			return PUPPY_SELL_STATUS[status]
		},

		processPendingPayment(data) {
			const selectedBuyerPayment = this.buyerDetails.find(tmp => tmp.userId === data.userId);
			this.$swal({
				title: "Update Payment",
				text: `Was the client payment successful or unsuccessful?`,
				confirmButtonText: "Successful",
				showCancelButton: true,
				cancelButtonText: "Unsuccessful",
				reverseButtons: true,
				showCloseButton: true
			}).then((result) => {
				
				if (!result.dismiss || (result.dismiss !== 'close' && 
						result.dismiss !== 'backdrop')) {
					
					let status = result.value ? 'APPROVED' : '';

					if (result.dismiss === 'cancel') {
						status = 'CANCELLED'
					}
					this.isPaymentLoading = true;
					PaymentAPI.puppyPurchaseManualProcessPendingPayment(this.puppySellId, selectedBuyerPayment.id, status)
						.then((res) => {
							if (res.status === STATUS_CODES.SUCCESS) {
								if (res.data.status === "PENDING") {
									this.showCustomSuccessToast(null, res.data.message)
								} else {
									this.showCustomSuccessToast(null, `Successfully updated the payment status.`)
								}
								this.getPuppySellingDetails(this.$route.params.id)
							} else {
								this.showAPIErrorToast(`Failed to update the payment status.`, res)
							}
						})
						.catch(() => {
							this.showGenericErrorToast()
						})
						.finally(() => {
							this.isPaymentLoading = false
						})
				}
			})
		},
		async updatePuppySellStatus(puppySellId, status) {
            try {
                const modalConfirmationRes = await this.$swal({
                    titleText: `Mark Puppy as ${PUPPY_SELL_STATUS[status]}`,
                    html: `<p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>Are you sure you want to update the puppy status to <strong style='color: #ff801e'>${PUPPY_SELL_STATUS[status]}</strong>?</p>`,
                    confirmButtonText: "Confirm",
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                    reverseButtons: true,
                    showCloseButton: true,
                });

                if (modalConfirmationRes.isConfirmed) {
                    this.isEditAPILoading = true;

                    const details = {
						buyerId: this.buyerDetails && Array.isArray(this.buyerDetails) ? this.buyerDetails[0].userId : null,
                        status,
                    };

                    const response =
                        await puppySellService.updatePuppyDetailsStatus(
                            puppySellId,
                            details
                        );

                    if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                        this.referenceNumber = null;
                        this.getPuppySellingDetails(this.$route.params.id);
                        this.showCustomSuccessToast(
                            `Successfully updated Puppy selling status to ${PUPPY_SELL_STATUS[status]}.`
                        );
                    } else {
                        const errorMessage = response.data.errors[0].message;

                        if (response.status === STATUS_CODES.BAD_REQUEST) {
                            this.showAPIErrorToast(errorMessage, response);
                        } else {
                            this.showGenericErrorToast();
                        }
                    }

                    this.isEditAPILoading = false;
                }
            } catch (err) {
                this.showGenericErrorToast();
            }
        },
		togglePuppyStatusOptions(){
			this.showPuppyStatusOptions = !this.showPuppyStatusOptions;
		},
		async onPuppyStatusChange(selectedStatus){
			if(!selectedStatus){
				return;
			}

			const formattedRes = selectedStatus ? PUPPY_SELL_STATUS[selectedStatus] : "";
			let htmlValue =`<p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>Are you sure you want to update the puppy status to <strong style='color: #ff801e'>${formattedRes}</strong>?</p>`

			if (this.buyerDetails && this.buyerDetails.length > 1 && PUPPY_SELL_STATUS[selectedStatus] === 'SOLD') {
				let optionHtml = ""
				this.buyerDetails.forEach(buyerDetail => {
					optionHtml +=`<option value="${buyerDetail.userId}">${buyerDetail.recipientName}</option>`
				})
				 htmlValue = ` <p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>Are you sure you want to update the puppy status to <strong style='color: #ff801e'>${formattedRes}</strong>?</p>
				  <div id="select-container">
				  	<p style='color: #596780; margin: .7rem 0rem .05rem 0;'>Please select a customer in the dropdown:</p>
					<select id="status-select" class="swal2-input" style="margin:0em auto">
						${optionHtml}
					</select>
				</div>`
			}

			const modalConfirmationRes = await this.$swal({
				titleText: `Update Puppy Status`,
				html: htmlValue,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				showCloseButton: true,
				preConfirm: () => {
					// Return the selected value from the select dropdown
					const selectedStatus = document.getElementById('status-select') ? document.getElementById('status-select').value: null;
					return selectedStatus; // This will be returned in the modal result
				  },
				  didOpen: () => {
					// You can initialize anything when the modal opens, like focusing on the select element
					if (document.getElementById('status-select')){
						const selectElement = document.getElementById('status-select');
						selectElement.focus();
					}
				  }
			  });

			const { isDismissed, isConfirmed } = modalConfirmationRes;

			// hide dropdown options
			if(isDismissed || isConfirmed){
				this.showPuppyStatusOptions = false;
			}

			if (isConfirmed) {
				const selectedUserId = modalConfirmationRes.value;
				const buyerId = this.buyerDetails && Array.isArray(this.buyerDetails) ? this.buyerDetails[0].userId : null; // fallback for buyerId
				const details = {
					buyerId: selectedUserId || buyerId,
					status: selectedStatus,
				};

				this.isEditAPILoading = true;

				try{
					const response = await puppySellService.updatePuppyDetailsStatusById(this.puppySellId , details);

					if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						await this.getPuppySellingDetails(this.$route.params.id);

						let successToastMessage = "Puppy status has been updated successfully.";

						// can't get it from a constant
						if(selectedStatus === 'A'){
							// reset reference number since 'A' or available status won't have transaction details which is the reference num.
							this.referenceNumber = null;
						}

						if(selectedStatus === PUPPY_SELL_STATUS.DELETED){
							this.$router.push('/pet-purchases/puppy-selling');
							successToastMessage = "Puppy has been deleted successfully."
						}

						this.showCustomSuccessToast(null, successToastMessage);
					} else {
						this.showAPIErrorToast("Unable to update puppy sell details.", response)
					}
				} catch(err){
					this.showGenericErrorToast();
				} finally{
					this.isEditAPILoading = false;
				}
			}

		},
	},
	validations() {
		return this.validationRules
	},
}
